import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface VerificationRecordState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allVerificationRecord: [] | null | any;
}

const initialState: VerificationRecordState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allVerificationRecord: null,
};

export const verificationRecordSlice = createSlice({
    name: 'VerificationRecord',
    initialState,
    reducers: {
        setVerificationRecord: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setVerificationRecordBySearch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllVerificationRecord: (state, action) => {
            state.allVerificationRecord = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setVerificationRecord, setVerificationRecordBySearch, setAllVerificationRecord, reset } = verificationRecordSlice.actions;
export const getAllVerificationRecordDetails = (state: RootState) => state.verificationRecord.data;
export const getVerificationRecordTotalRecords = (state: RootState) => state.verificationRecord.totalRecords;
export const getAllVerificationRecordBySearch = (state: RootState) => state.verificationRecord.data;
export default verificationRecordSlice.reducer;
